// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kFD-","questions":"styles_questions__IFVFG","footer":"styles_footer__1SRgT"};